module.exports = __webpack_public_path__ + "static/media/Phone.d9bace33.png";